export const GRAMPO_LIMPADOR_SOLO = {
    Codigo: 6,
    Nome: 'Grampo Limpador Solo',
    Modelo: 'CT-1300',
    Capa: null, 
    Home: true,
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Grampo_Limpador_Solo/grampo_2.png"
        }
        , {
            Url: "assets/IPB/Produtos/Grampo_Limpador_Solo/grampo_1.png"
        }
    ],
    Detalhes: [],
    Modelos: [
        { Modelo: `GRL-15G`, Detalhes: `Medidas 2,10x15 Garras` },
        { Modelo: `GRL-17G`, Detalhes: `Medidas 2,50x17 Garras` },
        { Modelo: `GRL-19G`, Detalhes: `Medidas 2,80x19 Garras` }
    ]
}